/// Dinheiro trafega pela API em centavos inteiros, então a interface só precisa saber exibir e ler
/// centavos. Ponto flutuante erra em soma de dinheiro, e aqui o número é o valor de um aporte ou de
/// uma compra — o erro apareceria na conferência com a realidade.

export function formatCents(cents: number): string {
  const negative = cents < 0;
  const digits = Math.abs(Math.trunc(cents)).toString().padStart(3, '0');
  const whole = digits.slice(0, -2);
  const fraction = digits.slice(-2);
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/gu, '.');
  return `${negative ? '-' : ''}${grouped},${fraction}`;
}

/// Símbolos das moedas atendidas. A separação de milhar e o decimal seguem a convenção brasileira
/// em todas: o operador do sistema lê em pt-BR, mesmo quando o preço é em dólar.
const SYMBOLS: Record<string, string> = {
  BRL: 'R$',
  USD: 'US$',
  ARS: 'AR$',
};

export function currencySymbol(currency = 'BRL'): string {
  return SYMBOLS[currency] ?? currency;
}

export function formatCurrency(cents: number, currency = 'BRL'): string {
  return `${currencySymbol(currency)} ${formatCents(cents)}`;
}

/// O verbo concorda com o valor lido em voz alta: "falta R$ 1,50" é "falta um real e cinquenta",
/// mas "faltam R$ 150,00" são cento e cinquenta reais. Só um centavo ou um real e uns trocados
/// pedem o singular.
export function readsAsPlural(cents: number): boolean {
  const amount = Math.abs(Math.trunc(cents));
  return amount !== 1 && (amount < 100 || amount >= 200);
}

/// Lê o que o operador digitou. Só os dígitos importam: os dois últimos são os centavos, como em
/// qualquer campo de valor bancário — digitar 1234 é R$ 12,34.
export function parseCentsFromDigits(input: string): number | null {
  const digits = input.replace(/\D/gu, '');
  if (digits === '') return null;
  return Number.parseInt(digits, 10);
}
